import { cacheExchange, createClient, fetchExchange } from "urql";
const GRAPHQL_API_PATH = '/api/v1/gql/query';
function stripTypenames(payload) {
    return JSON.parse(JSON.stringify(payload), (key, value)=>'__typename' === key ? void 0 : value);
}
function createUrqlClient(fetch) {
    const client = createClient({
        requestPolicy: 'cache-and-network',
        url: GRAPHQL_API_PATH,
        fetch,
        exchanges: [
            cacheExchange,
            fetchExchange
        ],
        preferGetMethod: false
    });
    return client;
}
export { GRAPHQL_API_PATH, createUrqlClient, stripTypenames };

//# sourceMappingURL=graphql-client.js.map